<template>
    <div>
        <Header/>
        <!-- <DomainSearch/> -->
        <Services/>
        <Pricing/>
        <WhyChooseUs/>        
        <CallToAction/>
        <Testimonial/>
        <FAQ/>
        <Brand/>
        <Quote/>
    </div>
</template>

<script>
import Header from "../components/Header.vue";
// import DomainSearch from "../components/DomainSearch.vue";
import Services from "../components/Service/ServiceGrid.vue";
import Pricing from "../components/Pricing.vue";
import WhyChooseUs from "../components/WhyChooseUs.vue";
import Testimonial from "../components/Testimonial.vue";
import CallToAction from "../components/CallToAction.vue";
//import Blog from "../components/Blog.vue";
import FAQ from "../components/Faq/FAQ.vue";
import Brand from "../components/Brand.vue";
import Quote from "../components/Quote.vue";


export default {
    name: "App",
    components: {
        Header, Pricing, WhyChooseUs, Testimonial, CallToAction, 
        //Blog, DomainSearch, 
        Services, Quote, FAQ, Brand
    },
};
</script>


